<template>
    <div>
        <rednax-datatable
            ref="tablepurchases"
            :url="'/vue/suppliers/purchases'"
            :columns="table_columns"
            :filter="table_filter"
            @updateFilter="table_filter=$event"
            history
            size="md"
            :per-page="100"
            sort-by="ProdPurchaseID"
            sort-order="asc"
            @rowclick="rowClick"
        >
            <div class="row">
                <div class="col-lg-3">
                    <input type="text" v-model="table_filter.search" class="form-control"  placeholder="Sök...">
                </div>
                <div class="col-lg-3">
                    <v-select
                        v-model="table_filter.supplier_id"
                        :options="suppliers"
                        :reduce="s => s.ProdSupplierID"
                        label="Name"
                        placeholder="ALLA LEVERANTÖRER"
                    ></v-select>
                </div>
                <div class="col-lg-3">
                    <v-select
                        v-model="table_filter.status_id"
                        :options="select_statuses"
                        :reduce="s => s.id"
                        label="name"
                        placeholder="ALLA BESTÄLLNINGAR"
                        :selectable="(option) => !option.disabled"
                    ></v-select>
                </div>
                <div class="col-lg-3">
                    <div class="custom-control custom-checkbox custom-control-inline mt-1">
                        <input id="chk-show-all" type="checkbox" class="custom-control-input" v-model="table_filter.is_confirmed" :true-value="0" :false-value="null">
                        <label for="chk-show-all" class="custom-control-label">Ej bekräftad</label>
                    </div>
                </div>
            </div>
            <template #cell_ProdPurchaseID="{ row }">
                <router-link :to="{ name: 'suppliers.purchase', params: { id: row.ProdPurchaseID } }">{{ row.ProdPurchaseID }}</router-link>
            </template>
            <template #cell_StatusID="{ row }">
                <span class="badge" :class="[ 'badge-' + row.status.BackgroundClass.substring(row.status.BackgroundClass.indexOf('-') + 1) ]">{{ row.status.StatusName }}</span>
            </template>
            <template #cell_ConfirmedTS="{ row }">
                <span v-if="row.StatusID >= 50 && row.ConfirmedTS" class="badge badge-success"><i class="icon-checkmark mr-1" style="font-size: 10px;"></i>Bekräftad</span>
                <span v-else class="badge badge-danger">Ej Bekräftad</span>
            </template>
        </rednax-datatable>
    </div>
</template>

<script>
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent';
import { formatDateTime } from '@services/Helpers';
import PurchaseStatusRepository from '@services/repositories/Purchase/PurchaseStatusRepository';
import SupplierRepository from '@services/repositories/SupplierRepository';
import vSelect from 'vue-select';
import apiClient from '@services/ApiClient';

export default {
    name: 'PurchaseList',
    components: {
        RednaxDatatable,
        vSelect,
    },
    data: () => ({
        statuses: [],
        suppliers: [],
        table_filter: {
            search: '',
            status_id: 'not_deliverd',
            is_confirmed: null,
        },
        table_columns: [
            {
                header: '#',
                data: 'ProdPurchaseID',
                sortable: true,
            },
            {
                header: 'Best.datum',
                data: 'CreatedTS',
                sortable: true,
                render: (row) => row.CreatedTS.substring(0, 10),
            },
            {
                header: 'Status',
                data: 'StatusID',
                sortable: true,
            },
            {
                header: 'Bekräftad',
                data: 'ConfirmedTS',
                sortable: true,
            },
            {
                header: 'Leverantör',
                data: 'SupplierName',
                sortable: true,
            },
            {
                header: 'Antal produkter',
                data: 'items',
                sortable: false,
                render: (row) => row.items.length,
            },
            {
                header: 'Beställare',
                data: 'OrderedByName',
                sortable: true,
            },
        ],
    }),
    mounted() {
        this.getStatuses();
        this.getSuppliers();
    },
    methods: {
        formatDateTime,
        async getStatuses() {
            const client = new PurchaseStatusRepository();
            this.statuses = await client.getAll();
        },
        async getSuppliers() {
            const client = new SupplierRepository();
            this.suppliers = await client.getAll();
        },
        async confirmPurchase(id) {
            let doConfirm = false;
            await this.$swal({
                text: 'Är du säker att du vill bekräfta denna beställning?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ja, bekräfta!',
            }).then((result) => {
                if (result.isConfirmed) {
                    doConfirm = true;
                }
            });
            if (doConfirm) {
                await apiClient.post('/vue/suppliers/purchases/' + id + '/confirm')
                    .then(() => {
                        this.$refs['btnconfirm' + id].triggerSaved();
                        setTimeout(() => {
                            this.$refs.tablepurchases.reload();
                        }, 1500);
                    }).catch(() => {
                        this.$refs['btnconfirm' + id].triggerFailed();
                    });
            }
        },
        rowClick(row) {
            this.$router.push({ name: 'suppliers.purchase', params: { id: row.ProdPurchaseID } });
        },
    },
    computed: {
        old_system_url() {
            return window.config.app.old_system_url;
        },
        select_statuses() {
            const arr = [...this.statuses];
            arr.unshift({ id: 'divider', name: '-----------------', disabled: true });
            arr.unshift({ id: 'not_deliverd', name: 'Ej levererad' });
            return arr;
        },
    },
};

</script>
